import type { ReactNode } from 'react'
import './SettingsSection.scss'

interface SettingsSectionProps {
  /** Uppercase section header, e.g. "DARSTELLUNG". */
  title: string
  /** Section content — usually a vertical stack of {@link SettingsRow}. */
  children: ReactNode
  className?: string
}

/**
 * Headed block within a Settings page. Title is rendered as an uppercase
 * caption (12px, semibold, muted). Body lays out rows vertically with the
 * spacing the Figma pattern expects.
 */
export function SettingsSection({ title, children, className }: SettingsSectionProps) {
  return (
    <section className={`settings-section ${className ?? ''}`.trim()}>
      <header className="settings-section__header">
        <h2 className="settings-section__title">{title}</h2>
      </header>
      <div className="settings-section__body">{children}</div>
    </section>
  )
}
